import React, { FC } from 'react'
import { DispatchBanner } from '@moonpig/web-shared-products'
import { useProductContext } from '../../../contexts/product'
import { ProductModuleSection } from '../ProductModuleSection'
import { ProductModule } from '../types'

export const DispatchCutOffBannerModule: FC<ProductModule> = props => {
  const [{ departmentInfo }] = useProductContext()

  return (
    <ProductModuleSection {...props}>
      <DispatchBanner
        dispatchCutOff={departmentInfo?.dispatchCutOff}
        py={4}
        px={6}
        borderRadius={1}
      />
    </ProductModuleSection>
  )
}
